export default function EmptyState({ icon, title, description, action, actionLabel }) {
  return (
    <div className="bg-white rounded-[12px] border border-[#E5E7EB] px-6 py-12 text-center">
      {icon && (
        <div className="w-12 h-12 rounded-full bg-surface flex items-center justify-center mx-auto mb-4">
          {icon}
        </div>
      )}
      <p className="text-[15px] font-semibold text-[#374151] mb-1">{title}</p>
      {description && (
        <p className="text-[13px] text-[#9CA3AF] mb-5 max-w-xs mx-auto leading-relaxed">{description}</p>
      )}
      {action && actionLabel && (
        <button
          onClick={action}
          className="bg-pb hover:bg-navy text-white text-[13px] font-semibold px-5 py-2.5 rounded-[8px] transition"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
